require("./style.scss")
class TagSelectorDirective
  @$inject: ["toasty", "selector", "editor", "warning", "Tag"]
  constructor: (toasty, selector, editor, warning, Tag)->       
    class TagSelector      
      restrict: "C"
      require: "^selector"            
      template: require('./index.pug')
      scope: true
      link: ($scope, $element, $attrs, $usage)->
        edit = 
          html: "<a><i class='fa fa-pencil-square-o'></i>Edit Info</a>"
          enabled: -> true
          click: (scope) =>
            {tag} = scope
            dirty = angular.copy(tag)
            options = 
              source: dirty
              schema:
                text:
                  type: "String"
                  display: "Tag"                        
            editor.edit(options).then (result)->        
              result.$save()
            .then (result)->
              angular.copy(result, tag)
              toasty.success
                title: 'Save Success'
                msg: "Save tag information success"
        install = 
          html: '<a><i class="fa fa-cogs">Install App</a>'
          enabled: -> true
          click: (scope) =>
            {tag} = scope
            options = 
              model: "Resource"
              filter:
                type: ["FOLDER", "APK", "CPK"]
            selector.select(options).then (resource)->
              tag.$install(resource)
            .then ()->        
              toasty.success
                title: 'Install App Started'
                msg: "Started to install the application to tagged devices"
        reboot = 
          html: '<a><i class="fa fa-power-off">Reboot</a>'
          enabled: -> true
          click: (scope) =>
            {tag} = scope
            options = 
              title: "Reboot Devices"
              msg: "Would you confirm to reboot all #{tag.text} devices?"            
            warning.warn(options).then ()->      
              tag.$reboot()
            .then ()=>
              toasty.success
                title: 'Reboot Started'
                msg: "Started to reboot #{tag.text} devices"

        remove =
          html: '<a><i class="fa fa-trash"></i>Remove</a>'
          click: (scope) ->
            {tag, $resource} = scope
            options = 
              title: "Remove Tag"
              msg: "Would you confirm to remove this?"            
            warning.warn(options).then ()->      
              tag.$remove()
            .then ()=>
              $resource.refresh()
              toasty.success
                title: 'Remove Success'
                msg: "Remove Tag #{tag.text} success"

        $scope.create = ($resource)->
          tag = new Tag()
          options = 
            title: "Create tag"
            source: tag        
            schema: 
              text: 
                type: "String"
                display: "Text"
                required: true
          editor.edit(options).then (result)->
            result.$save()
          .then (result)->
            toasty.success
              title: 'Create Tag Success'
              msg: "Create tag #{tag.text} success"
            $resource.refresh()
        $scope.menu = [edit, install, reboot, remove]    

    return new TagSelector()

  
module.exports = TagSelectorDirective


// WEBPACK FOOTER //
// ./src/component/tag/selector/index.coffee